import './oiSingleNews.css';
import React, { Component } from 'react';
import RenderHTML from 'react-render-html';

class oiSingleNews extends Component {
    constructor(props) {
        super(props);
        this.state = { imageIsLoaded: false };
        this.imageIsLoadedHandler = this.imageIsLoadedHandler.bind(this);
    }

    imageIsLoadedHandler = () => {
        this.setState({ imageIsLoaded: true });
    }

    render = () => {
        let imageRender = '';

        if (this.props.image) {
            imageRender = (
                <React.Fragment>
                    <img
                        alt="News"
                        src={`${process.env.PUBLIC_URL}/imgs/placeholder.png`}
                        className={
                            this.state.imageIsLoaded ?
                                "visibility-off" :
                                "oi-single-news-img"
                        }
                    />
                    <img
                        alt="News"
                        src={this.props.image}
                        onLoad={this.imageIsLoadedHandler}
                        className={
                            this.state.imageIsLoaded ?
                                "oi-single-news-img" :
                                "visibility-off"
                        }
                    />

                </React.Fragment>

            );
        }

        return (
            <div className="oi-single-news">
                <div className="oi-single-news-layer" data-id={this.props.id} onClick={this.props.clickEvent}></div>

                {imageRender}

                <div className="oi-single-news-info">
                    <h3>{this.props.title}</h3>
                    <p>{RenderHTML(this.props.text)}</p>
                    <p>{RenderHTML(this.props.humanDate)} <span>em {this.props.channel}</span></p>
                </div>
            </div>
        );
    }
};

export default oiSingleNews;


// WEBPACK FOOTER //
// ./src/components/oiSingleNews/oiSingleNews.js